import React, { Fragment, useContext, useState } from "react";
import { SessionContext } from "../../../utility/useSession";
import propTypes from "prop-types";
import { AssetLocation, AssetLocationTypes, KeyAuditType, KeyManagementTypes } from "../../../logic/api";
import KeyAuditScanner from "../keyAudit/KeyAuditScanner";
import { Button, Dialog, DialogActions, DialogContent, DialogTitle } from "@mui/material";
import KeyAuditsDueAtLocation from "../../locations/components/KeyAuditsDueAtLocation";
import { useTranslation } from "react-i18next";
import { usePreferences } from "@/utility/usePreferences";
import { ReleaseFlag, useReleaseManagement } from "@/utility/feature-management";

const KeyAuditsDue: React.FunctionComponent<{
    show: boolean;
    onClose: () => void;
}> = (props) => {
    const session = useContext(SessionContext);
    const { t } = useTranslation();

    const [location, setLocation] = useState<AssetLocation | null>();
    const [showAuditScanner, setShowAuditScanner] = useState(false);

    const preferences = usePreferences();

    const isKeyAuditDueCriteriaReleased = useReleaseManagement(ReleaseFlag.releaseKeyAuditDueCriteria);

    const enforceKeyPositionAudit = () => {
        if (isKeyAuditDueCriteriaReleased) {
            if (location?.type && [AssetLocationTypes.Keyroom, AssetLocationTypes.KeyBox, AssetLocationTypes.Hook].includes(location?.type)) {
                return false;
            } else {
                return (preferences.enable_enforce_key_position_audit && preferences.keyAuditSettings?.lane.auditType === KeyAuditType.Order)
            }
        } else {
            return preferences.enable_enforce_key_position_audit;
        }
    };

    if (session.current.site == null || session.current.site.home == null) {
        return <Fragment></Fragment>;
    }

    return <Fragment>
        <Dialog open={props.show}>
            <DialogTitle>
                {t("keys.labels.selectDueAudit")}
            </DialogTitle>
            <DialogContent>
                <div style={{ minHeight: 400, minWidth: 400 }}>
                    <KeyAuditsDueAtLocation path={`/${session.current.site.home.id}/`} onSelected={(loc) => {
                        setLocation(loc);
                        setShowAuditScanner(true);
                    }}></KeyAuditsDueAtLocation>
                </div>
            </DialogContent>
            <DialogActions>
                <Button onClick={() => {
                    props.onClose();
                }}>
                    {t("general.cancel")}
                </Button>

            </DialogActions>
        </Dialog>
        {location != null && (
            <KeyAuditScanner
                show={showAuditScanner}
                enforceKeyPositionAudit={enforceKeyPositionAudit()}
                onClose={() => {
                    setShowAuditScanner(false);
                    props.onClose();
                }}
                location={location}
            />
        )}


    </Fragment>
}

KeyAuditsDue.propTypes = {
    show: propTypes.bool.isRequired,
    onClose: propTypes.func.isRequired
}

export default KeyAuditsDue;